module.exports = __webpack_public_path__ + "img/chevron-left.63ebd9e6.svg";